import axios from "axios";

export default (state = {
    fetching: true,
    fetched: false,
    logging: false,
    logged: true,
    logged_in: false,
    business: {},
    businesses: [],
    user: {},
    requires_relogin: false,
    relogin_reload: false,
    can_request: true,
}, action) => {
    switch (action.type) {
        case 'AUTH_REQUIRES_RELOGIN':
            return {
                ...state,
                requires_relogin: action.payload.status,
                relogin_reload: action.payload.relogin_reload
            };
        case 'AUTH_FETCHING' :
            return {
                ...state,
                logging: true,
                logged: false,
            };
        case 'AUTH_FETCHED_LOGIN' :
            if (action.results.logged_in && action.results.user && action.results.user.token) {
                // axios.defaults.headers['Authorization'] = 'Bearer ' + action.results.user.token;
                localStorage.setItem('auth_token', action.results.user.token)
            }
            return {
                ...state, ...action.results,
                logging: false,
                logged: true,
                fetching: false,
                fetched: true,
                requires_relogin: false
            };

        case 'AUTH_LOGIN_FAILED' :
            // localStorage.setItem('auth_token',null)
            return {
                ...state,
                logging: false,
                logged: true,
            };
        case 'AUTH_LOGGED_OUT' :
            localStorage.setItem('auth_token', null)
            return {
                ...state,
                fetching: false,
                fetched: true,
                logged_in: false,
                business: {},
                businesses: [],
                user: {},
            };
        case 'AUTH_CHECK' :
            return {
                ...state,
                fetching: false,
                fetched: true,
            };
        case 'FETCHING_AUTH_FAILED' :
            // localStorage.setItem('auth_token',null)
            return {
                ...state,
                fetching: false,
                fetched: false,
            };
        case 'SELECT_DEFAULT_BUSINESS':
            return {
                ...state,
                business: {...action.business}
            };
        default:
            return state;
    }
};
